import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/styles";
import {
  CardActions,
  Divider,
  Drawer,
  Hidden,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { Profile, SidebarNav } from "./components";
import sidebarPages, {
  fieldTechnicianEstimatorSidebarPages,
  fieldTechnicianEstimatorScheduleSidebarPages,
  fieldTechnicianSidebarPages,
  groupAdminSidebarPages,
  superAdminSidebarPages,
} from "./SidebarPages";
import { Footer } from "../";
import axios from "utils/axios";
import apiConfig from "apiConfig";
import { useDispatch, useSelector } from "react-redux";
import localStorage from "utils/localStorage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { checkMultiRoles, PERMISSIONS, canUpdateTeammateStatus } from "common/permissions";
import { increaseDate } from "utils/date-time";
import InputIcon from "@material-ui/icons/Input";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import ModalAllEmployees from "../../../../views/EmployeeRoutes/components/ModalAllEmployees";
import { checkFeature, FeatureFlags } from "FeatureService";
import { OpenInBrowser } from "@material-ui/icons";
import useSharedLocationTracking from "hooks/useSharedLocationTracking";
import LocationCapture from "components/LocationCapture";
import LocationStatus from "components/LocationStatus";

const sidebars = {
  "Field Technician": fieldTechnicianSidebarPages,
  "System Admin": superAdminSidebarPages,
};

// Deep-clones the plain-object/array page-definition tree without touching non-plain
// values (icon component references are classes/functions) - JSON.parse(JSON.stringify())
// would silently drop those. Needed because the per-user payroll-link rewrite below used
// to mutate the shared, module-level exported sidebar page arrays in place via a shallow
// `[...pages]` spread, which only copies the top-level array - every login after the first
// kept clobbering the same shared objects.
const deepClonePageTree = (value) => {
  if (Array.isArray(value)) {
    return value.map(deepClonePageTree);
  }
  if (value && typeof value === "object" && value.constructor === Object) {
    const clone = {};
    Object.keys(value).forEach((key) => {
      clone[key] = deepClonePageTree(value[key]);
    });
    return clone;
  }
  return value;
};

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 265,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    overflowX: "hidden",
    overflowY: "auto",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up("lg")]: {
      marginTop: 64,
      height: "calc(100% - 64px)",
    },
  },
  collapse: {
    [theme.breakpoints.up("lg")]: {
      width: 77,
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  nav: {
    //marginBottom: theme.spacing(2)
  },
  otherItems: {
    marginTop: -8
  },
  signOutButton: {
    display: "flex",
    width: "100%",
    height: "44px",
    borderRadius: "4px",
    fontSize: "24px",
    justifyContent: "left",
    paddingLeft: "10px",
    fontWeight: "500",
    color: "#546e7a",
  },
  logoutText: {
    marginLeft: "8px",
    fontWeight: "500",
    color: "#36464e",
  },
  statusSelect: {
    width: "calc(100% - 24px)",
  },
}));

let mounted;
const Sidebar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"), {
    defaultMatches: true,
  });
  const { open, variant, onOpen, onClose, className, ...rest } = props;
  const { reloadCustomer } = useSelector((state) => state.CountReducer);
  const [status, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState();
  const [lastStatusUpdate, setLastStatusUpdate] = useState(0);
  const [isStatus, setIsStatus] = useState({ failed: false, msg: "" });
  const [openSnackbar, setOpenSnackBar] = useState(false);
  const [clocking, setClocking] = useState(false);

  const [openConfirmAllEmployees, setOpenConfirmAllEmployees] = useState(false);
  const [listEmployeesActive, setListEmployeesActive] = useState([]);

  // Location tracking - shared across sidebar and main page
  const { location: capturedLocation, captureLocation, permission } = useSharedLocationTracking();
  const [showLocationDialog, setShowLocationDialog] = useState(false);
  const [pendingClockAction, setPendingClockAction] = useState(null);

  const userRoles = localStorage.getUserRoles();
  const isHasRoleClockInClockOut = checkMultiRoles(
    userRoles,
    PERMISSIONS.control.clockInClockOut
  );

  const [counts, setCounts] = useState(null);
  const [countsTask, setCountsTask] = useState(null);
  const [bidtodo, setBidtodo] = useState();
  const [sidebarData, setSidebarData] = useState();
  const [selectCurrentStatus, setSelectCurrentStatus] = useState();
  const [fieldTech, setFieldTech] = useState(false);
  const [isSqueegeeSquad, setIsSqueegeeSquad] = useState(false);
  const dispatch = useDispatch();
  const { reloadLogHourSideBar, reloadTaskSideBar } = useSelector((state) => state.AppReducer);
  const [countsRecurRoutes, setCountsRecurRoute] = useState(null);
  const [monthlyBillingCount, setMonthlyBillingCount] = useState(null);

  const fetchCounts = () => {
    axios
      .get(apiConfig.url.CUSTOMER_URL + apiConfig.url.CUSTOMERS_GET_COUNT)
      .then((res) => {
        mounted && setCounts(res.data.counts);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(err);
        }
      });
  };
  const fetchCountsTask = () => {
    const user = localStorage.getFullInfo();
    axios
      .get(apiConfig.url.BASE_URL + apiConfig.url.EMPLOYEE_COUNT_TASK, { params: { employeeId: user.nameid } })
      .then((res) => {
        mounted && setCountsTask(res.data);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(err);
        }
      });
  };

  const fetchRecurRoutesCount = () => {
    // Use new template endpoint for count
    axios
      .get(apiConfig.url.BASE_URL + 'api/templates/recurring-routes', {
        params: { page: 1, pageSize: 1 }
      })
      .then((res) => {
        // Extract total count from paginated response
        mounted && setCountsRecurRoute(res.data.totalCount || res.data.data?.length || 0);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(err);
        }
      });
  };

  const fetchMonthlyBillingCount = () => {
    axios
      .get(apiConfig.url.BASE_URL + apiConfig.url.MONTHLY_INVOICES_UNSENT_COUNT)
      .then((res) => {
        const total = (res.data.unsentCount || 0) + (res.data.overdueCount || 0);
        mounted && setMonthlyBillingCount(total);
      })
      .catch(() => {});
  };

  const getPeriodDateString = (periodstartdate, periodduration) => {
    let periodDate = null;
    if (periodstartdate) {
      const date = periodstartdate.split("-");
      const sd = new Date(
        parseInt(date[0]),
        parseInt(date[1]),
        parseInt(date[2])
      );
      const periodEndDate = increaseDate(sd, periodduration * 7);

      const enddate = `${periodEndDate.getFullYear()}-${periodEndDate.getMonth() +
        1}-${periodEndDate.getDate()}`;
      periodDate = { startdate: periodstartdate, enddate };
    } else {
      const periodEndDate = new Date();
      const periodStartDate = increaseDate(periodEndDate, -7);
      const startdate = `${periodStartDate.getFullYear()}-${periodStartDate.getMonth() +
        1}-${periodStartDate.getDate()}`;
      const enddate = `${periodEndDate.getFullYear()}-${periodEndDate.getMonth() +
        1}-${periodEndDate.getDate()}`;
      periodDate = { startdate, enddate };
    }

    return periodDate;
  };
  const getEmployeeStatus = () => {
    return axios.get(
      apiConfig.url.BASE_URL + apiConfig.url.HOURS_LOG_EMPLOYEE_STATUS
    );
  };
  const loadJob = (id = null) => {
    const user = localStorage.getFullInfo();
    if (!user) return;

    Promise.all([
      axios.get(
        apiConfig.url.BASE_URL +
        apiConfig.url.EMPLOYEE_ROUTE_JOB.replace(
          "{userId}",
          user.nameid
        ).replace(
          "{date}",
          moment().startOf('day').toISOString()
        )
      ),
      getEmployeeStatus(),
    ])
      .then(([resJob, resStatus]) => {
        if (resJob.data) {
          let orderedJob = resJob.data.sort(
            (a, b) => new Date(a.scheduledTime) - new Date(b.scheduledTime)
          );
          let lstStatus = [...resStatus.data];
          let jobsiteStatusIdx = lstStatus.findIndex((s) => s.id === 2);
          var uniqJobs = orderedJob.filter(
            (job, index, self) =>
              self.findIndex((s) => s.jobSplitId === job.jobSplitId) === index
          );
          if (uniqJobs.length > 0) {
            lstStatus.splice(
              jobsiteStatusIdx,
              1,
              ...uniqJobs.map((d) => ({
                id: 2,
                description: `Job Site${d.jobsiteAddress1 ? ` - ${d.jobsiteAddress1}` : ""
                  }`,
                jobSplitId: d.jobSplitId,
              }))
            );
          }
          setStatus(lstStatus);
        } else {
          let lstStatus = [...resStatus.data];
          setStatus(lstStatus);
          setSelectStatus("6_");
        }
      })
      .finally(() => {
        // Don't call getRouteDetail here - it causes race conditions
        // when status is updated, as it may fetch stale data
      });
  };

  const onEmployeeStatusChanged = async (all, event) => {
    setOpenConfirmAllEmployees(false);
    if (!isHasRoleClockInClockOut) {
      return;
    }
    setClocking(true);
    
    // Try to capture location if not already captured
    let location = capturedLocation;
    if (!location) {
      try {
        location = await captureLocation();
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.log('Could not capture location:', err);
        }
        // Don't auto-show dialog - let user continue without location
        // User can manually click the location tracking link if they want to fix it
        // This prevents blocking the clock in/out flow
      }
    }
    
    let value = event && event.target.value;
    let arr = value
      ? value.split("_")
      : (selectCurrentStatus && selectCurrentStatus.split("_")) ||
      selectStatus.split("_");
    
    if (process.env.NODE_ENV === 'development') {
      console.log('[Sidebar] Status change starting:', {
        value,
        selectCurrentStatus,
        selectStatus,
        arr,
        willSetTo: arr.join('_'),
        timestamp: new Date().toISOString()
      });
    }
    
    let lstPromise = [];
    if (all) {
      listEmployeesActive.forEach((id) => {
        const data = {
          employeeId: id.id,
          date: moment().startOf('day').toISOString(),
          hoursLogEmployeeStatusId: arr[0],
          jobSplitId: arr[1] || null,
        };
        
        // Add location if available
        if (location) {
          data.location = {
            latitude: location.latitude,
            longitude: location.longitude,
            accuracy: location.accuracy,
            notes: null
          };
        }
        
        lstPromise.push(
          axios.put(
            apiConfig.url.BASE_URL + apiConfig.url.HOURS_LOG_EMPLOYEE_STATUS,
            data
          )
        );
      });
    } else {
      const user = localStorage.getFullInfo();
      const data = {
        employeeId: user.nameid,
        date: moment().startOf('day').toISOString(),
        hoursLogEmployeeStatusId: arr[0],
        jobSplitId: arr[1] || null,
      };
      
      // Add location if available
      if (location) {
        data.location = {
          latitude: location.latitude,
          longitude: location.longitude,
          accuracy: location.accuracy,
          notes: null
        };
      }
      
      lstPromise.push(
        axios.put(
          apiConfig.url.BASE_URL + apiConfig.url.HOURS_LOG_EMPLOYEE_STATUS,
          data
        )
      );
    }
    Promise.all(lstPromise)
      .then((res) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[Sidebar] API response received:', {
            success: !res.find((x) => !x.data.isSuccess),
            responses: res.map(r => ({ isSuccess: r.data.isSuccess, id: r.data.id })),
            timestamp: new Date().toISOString()
          });
        }
        
        if (!res.find((x) => !x.data.isSuccess)) {
          // Check if the server detected stale state (employee was already in this status)
          const staleResponse = res.find(x => x.data.isStale);
          if (staleResponse) {
            setIsStatus({ failed: false, msg: 'Status already up to date — refreshing...' });
            setOpenSnackBar(true);
            getRouteDetail();
            dispatch({ type: "RELOAD_LOG_HOUR" });
          } else {
            // Update the dropdown to reflect the new status FIRST
            const newStatus = arr.join('_');
            if (process.env.NODE_ENV === 'development') {
              console.log('[Sidebar] Setting status after success:', {
                newStatus,
                currentStatus: selectStatus,
                timestamp: new Date().toISOString()
              });
            }

            setSelectStatus(newStatus);
            setLastStatusUpdate(Date.now()); // Record when we manually set the status

            // Then show success message
            setIsStatus({ failed: false, msg: "Record Updated" });
            setOpenSnackBar(true);

            // Finally reload sidebar data
            // Use setTimeout to ensure state update completes first
            setTimeout(() => {
              dispatch({ type: "RELOAD_LOG_HOUR" });
            }, 0);
          }
        } else {
          if (process.env.NODE_ENV === 'development') {
            console.log('[Sidebar] API returned failure');
          }
          setIsStatus({
            failed: true,
            msg: "Payroll has not been enabled yet. Please contact the administrator.",
          });
          setOpenSnackBar(true);
        }
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          console.error('[Sidebar] API error:', error);
        }
        setIsStatus({
          failed: true,
          msg: "Update failed, please try again later.",
        });
        setOpenSnackBar(true);
      })
      .finally(() => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[Sidebar] Status change complete');
        }
        setClocking(false);
      });
  };

  const clockInEmployees = (event) => {
    // WI #4460: only offer "change everyone's status" to users who can manage teammates'
    // hours (Crew Lead / admins) - everyone else just updates themselves.
    if (listEmployeesActive && listEmployeesActive.length > 1 && canUpdateTeammateStatus(userRoles)) {
      setOpenConfirmAllEmployees(true);
    } else {
      onEmployeeStatusChanged(false, event);
    }
  };

  const handleLocationCaptured = (location) => {
    setShowLocationDialog(false);
    
    // Location is now in shared state, retry the clock action
    if (pendingClockAction) {
      onEmployeeStatusChanged(pendingClockAction.all, pendingClockAction.event);
      setPendingClockAction(null);
    }
  };

  const handleLocationSkip = () => {
    // Always close dialog first
    setShowLocationDialog(false);
    
    // Clear any pending action - user chose to skip
    setPendingClockAction(null);
  };

  const getRouteDetail = () => {
    const user = localStorage.getFullInfo();
    axios
      .get(
        apiConfig.url.BASE_URL +
        apiConfig.url.EMPLOYEE_ROUTE_DETAIL.replace(
          "{userId}",
          user.nameid
        ).replace(
          "{date}",
          moment().startOf('day').toISOString()
        )
      )
      .then((res) => {
        // Don't overwrite status if we just manually set it (within last 2 seconds)
        const timeSinceLastUpdate = Date.now() - lastStatusUpdate;
        if (process.env.NODE_ENV === 'development') {
          console.log('[Sidebar] getRouteDetail response:', {
            timeSinceLastUpdate,
            willSkip: timeSinceLastUpdate < 2000,
            apiStatus: res.data.hoursLog ? 
              `${res.data.hoursLog.hoursLogEmployeeStatusId}_${res.data.hoursLog.jobSplitId || ""}` : 
              '6_',
            currentStatus: selectStatus,
            timestamp: new Date().toISOString()
          });
        }
        
        if (timeSinceLastUpdate < 2000) {
          // Skip status update - we just set it manually
          if (process.env.NODE_ENV === 'development') {
            console.log('[Sidebar] Skipping status update from API - recently set manually');
          }
        } else {
          // Safe to update from API
          if (res.data.hoursLog && !res.data.hoursLog.workEnd) {
            const apiStatus = `${res.data.hoursLog.hoursLogEmployeeStatusId}_${res.data.hoursLog.jobSplitId || ""}`;
            if (process.env.NODE_ENV === 'development') {
              console.log('[Sidebar] Updating status from API:', apiStatus);
            }
            setSelectStatus(apiStatus);
          } else {
            if (process.env.NODE_ENV === 'development') {
              console.log('[Sidebar] Setting status to Off The Clock (6_)');
            }
            setSelectStatus("6_"); // hard coded - Off The Clock
          }
        }
        
        if (res.data.coWorkers) {
          let lst = res.data.coWorkers.map((x) => {
            return {
              ...x,
              id: x.employeeIdString,
              name: x.firstName + x.lastName,
            };
          });
          setListEmployeesActive(lst);
        }
      })
      .finally(() => { });
  };

  const handleToggleDrawer = () => {
    if (open) onClose();
    else onOpen();
  };

  const logout = () => {
    localStorage.clearAll();
    sessionStorage.clear();
    window.location.reload();
  };
  useEffect(() => {
    loadJob();
    // Also reload the current employee status when job status changes
    getRouteDetail();
  }, [reloadLogHourSideBar]);

  useEffect(() => {
    // Load initial employee status on mount with delay to allow database sync
    // This prevents race condition when user switches devices quickly
    const timer = setTimeout(() => {
      getRouteDetail();
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    mounted = true;
    const userRole = localStorage.getUserRole();
    if (userRole !== PERMISSIONS.FIELD_TECHNICIAN) {
      fetchCounts();
      fetchCountsTask();
      fetchRecurRoutesCount();
      fetchMonthlyBillingCount();
      axios
        .get(apiConfig.url.BASE_URL + apiConfig.url.DASHBOARD_BILL_TO_DO_COUNT)
        .then((res) => {
          mounted && setBidtodo(res.data);
        });
    }
    const companyId = localStorage.getCompanyId();
    axios.get(apiConfig.url.BASE_URL + apiConfig.url.COMPANY_BASIC.replace('{companyId}', companyId)).then(res => {
      setIsSqueegeeSquad(res.data && res.data.isSqueegeeSquad);
    })
    return () => (mounted = false);
  }, [reloadCustomer]);

  useEffect(() => {
    mounted = true;

    (async () => {
      if (mounted) {
        const userRoles = localStorage.getUserRoles();

        let pages = fieldTechnicianSidebarPages;
        if (userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN_ESTIMATOR)) {
          pages = fieldTechnicianEstimatorSidebarPages;
        }
        if (userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN_ESTIMATOR_SCHEDULE)) {
          pages = fieldTechnicianEstimatorScheduleSidebarPages;
        }
        if (userRoles.includes(PERMISSIONS.COMPANY_ADMINISTRATOR) || userRoles.includes(PERMISSIONS.OFFICE_STAFF)) {
          pages = sidebarPages;
        }
        if ((userRoles.includes(PERMISSIONS.GROUP_ADMIN) || userRoles.includes(PERMISSIONS.COMPANY_GROUP_ADMINISTRATOR)) && !userRoles.includes(PERMISSIONS.SUPER_ADMIN)) {
          pages = groupAdminSidebarPages;
        }
        if (userRoles.includes(PERMISSIONS.SUPER_ADMIN)) {
          pages = superAdminSidebarPages;
        }

        const data = deepClonePageTree(pages);
        const customerPages = data[0].pages.find(
          (page) => page.title === "Customers"
        );
        const employeesPages = data[0].pages.find(
          (page) => page.title === "Employees" || page.title === "Employee"
        );

        const schedulePages = data[0].pages.find(
          (page) => page.title === "Schedules"
        );

        const isEnableTasks = await checkFeature(
          FeatureFlags.TASKS
        );

        const isEnableRecurringRoutes = await checkFeature(
          FeatureFlags.MANAGE_RECUR
        );
        if (isEnableRecurringRoutes) {
          const scheduleNotUsePages = data[0].pages.find(
            (page) => page.title === "Schedules" && page.expandable === false
          );
          var index = data[0].pages.indexOf(scheduleNotUsePages);
          if (index >= 0)
            data[0].pages.splice(index, 1);
        }
        else {
          const scheduleUsePages = data[0].pages.find(
            (page) => page.title === "Schedules" && page.expandable === true
          );
          var index = data[0].pages.indexOf(scheduleUsePages);
          if (index >= 0)
            data[0].pages.splice(index, 1);
        }
        // get information of the logged user for redirect
        // Keyed off the "Payroll Access" stackable role instead of "is a single-role field
        // tech" - the old length===1 check meant a field tech with any second role (even an
        // unrelated one) never got a working payroll link at all, and conversely gave every
        // single-role field tech a working link whether or not they were meant to have one.
        const isFieldTechVariant = userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN) || userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN_ESTIMATOR) || userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN_ESTIMATOR_SCHEDULE);
        if (isFieldTechVariant && userRoles.includes(PERMISSIONS.PAYROLL_ACCESS)) {
          const {
            displayname,
            nameid,
            periodstartdate,
            periodduration,
          } = localStorage.getFullInfo();
          // href for the employee detail
          const manageUrl = `/employees/${encodeURIComponent(displayname)}/${nameid}/information`;
          // href for the payroll detail
          // const { startdate, enddate } = getPeriodDateString(
          //   periodstartdate,
          //   periodduration
          // );
          const startDate = moment().startOf('week').add(-periodduration, 'weeks');
          const endDate = moment().startOf('week');
          var date_object = {};
          if (new Date(periodstartdate).getDay() === 0) {
            date_object.startDate = startDate.toISOString();
            date_object.endDate = endDate.add(-1, 'days').toISOString();
          } else {
            date_object.startDate = startDate.add(1, 'days').toISOString();
            date_object.endDate = endDate.toISOString();
          }
          const s = new Date(date_object.startDate);
          const e = new Date(date_object.endDate);

          const sy = s.getFullYear();
          const sm = s.getMonth() + 1 > 9 ? s.getMonth() + 1 : `0${s.getMonth() + 1}`;
          const sd = s.getDate() > 9 ? s.getDate() : `0${s.getDate()}`;

          const ey = e.getFullYear();
          const em = e.getMonth() + 1 > 9 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`;
          const ed = e.getDate() > 9 ? e.getDate() : `0${e.getDate()}`;

          const startdate = `${sy}-${sm}-${sd}`;
          const enddate = `${ey}-${em}-${ed}`;
          const payrollUrl = `/employees/payroll-detail/${encodeURIComponent(displayname)}/${nameid}/${startdate}/${enddate}`;

          if (employeesPages) {
            employeesPages.href = manageUrl;
            const payrollPage = employeesPages.children.find(x => x.href === '/employees/payroll-detail');
            if (payrollPage) payrollPage.href = payrollUrl;
          }
        } else if (isFieldTechVariant && employeesPages) {
          // No Payroll Access - the static placeholder href (/employees/payroll-detail,
          // missing its required :name/:id/:startdate/:enddate params) never gets rewritten
          // above, so it must not be left in the menu either - it would 404 if clicked.
          employeesPages.children = employeesPages.children.filter(x => x.href !== '/employees/payroll-detail');
        }

        const isEnableExpiringDocuments = await checkFeature(
          FeatureFlags.EXPIRING_DOCUMENTS
        );


        if (!userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN) && !userRoles.includes(PERMISSIONS.FIELD_TECHNICIAN_ESTIMATOR)) {
          setFieldTech(false);
        }
        else {
          setFieldTech(true);
        }

        if (employeesPages && countsTask) {
          if (isEnableTasks) {
            const tasksPage = employeesPages.children.find(x => x.href === '/employees/tasks');
            if (tasksPage) tasksPage.title = `Tasks (${countsTask || "0"})`;
          }
          if (employeesPages && !isEnableTasks) {
            employeesPages.children = employeesPages.children.filter(
              (c) => c.href !== "/employees/tasks"
            );
          }
        }

        if (schedulePages && schedulePages.children && isEnableRecurringRoutes && countsRecurRoutes) {
          const recurrPage = schedulePages.children.find(x => x.href === '/schedules/recurring-routes');
          if (recurrPage) recurrPage.title = `Recurring Routes (${countsRecurRoutes || "0"})`;
        }

        if (counts && bidtodo !== undefined && pages) {
          if (customerPages) {
            const bidsPage = customerPages.children.find(x => x.href === '/customers/bidtodo');
            if (bidsPage) bidsPage.title = `Bids to do (${bidtodo || "0"})`;

            const salesPage = customerPages.children.find(x => x.href === '/customers/salefollowups');
            if (salesPage) salesPage.title = `Sales Follow Ups (${counts[2].count || "0"})`;

            const documentsPage = customerPages.children.find(x => x.href === '/customers/expiringdocuments');
            if (documentsPage) documentsPage.title = `Expiring Documents (${counts[3].count || "0"})`;

            const duplicatesPage = customerPages.children.find(x => x.href === '/customers/duplicate');
            if (duplicatesPage) duplicatesPage.title = `Duplicates (${counts[1].count || "0"})`;

            const missingTaxGroupPage = customerPages.children.find(x => x.href === '/customers/missingtaxgroup');
            if (missingTaxGroupPage) missingTaxGroupPage.title = `Missing Tax Groups (${counts[0].count || "0"})`;

            if (monthlyBillingCount > 0) {
              const monthlyBillingPage = customerPages.children.find(x => x.href === '/customers/billing');
              if (monthlyBillingPage) monthlyBillingPage.title = `Billing (${monthlyBillingCount})`;
            }
          }
        }
        if (customerPages && !isEnableExpiringDocuments) {
          customerPages.children = customerPages.children.filter(
            (c) => c.href !== "/customers/expiringdocuments"
          );
        }
        //admin sibar used feature flag
        const isEnableCommunicationCenter = await checkFeature(
          FeatureFlags.COMMUNICATION_CENTER
        );
        const isEnableCustomForm = await checkFeature(FeatureFlags.CUSTOM_FORM);
        const adminPages = data[0].pages.find((page) => page.title === "Admin");
        if (pages && adminPages) {

          if (!isEnableCustomForm) {
            adminPages.children = adminPages.children.filter(
              (c) => c.href !== "/admin/custom-forms"
            );
          }
        }
        setSidebarData(data);
      }
    })();

    return () => (mounted = false);
  }, [counts, bidtodo, countsTask, countsRecurRoutes, monthlyBillingCount]);

  if (sidebarData) {
    return (
      <Drawer
        anchor="left"
        classes={{ paper: clsx(classes.drawer, !open ? classes.collapse : "") }}
        onClose={onClose}
        open={open}
        variant={variant}
      >
        <div {...rest} className={clsx(classes.root, className)}>
          <Profile onClose={!isDesktop ? onClose : null} open={open} />
          <Divider className={classes.divider} />
          <div>
            {(open || !isDesktop) && status && status.length > 0 && (
              <>
                <CardActions style={{ flexDirection: 'column', alignItems: 'stretch', padding: '8px 12px' }}>
                  <TextField
                    className={classes.statusSelect}
                    // size={"small"}
                    name="status"
                    SelectProps={{ native: true }}
                    variant="outlined"
                    select
                    label="Clock In/Clock Out"
                    //disabled={!currentDate}
                    value={selectStatus}
                    onChange={(event) => {
                      const newValue = event.target.value;
                      if (process.env.NODE_ENV === 'development') {
                        console.log('[Sidebar] Dropdown changed:', {
                          from: selectStatus,
                          to: newValue,
                          timestamp: new Date().toISOString()
                        });
                      }
                      // Update dropdown immediately for responsive UI
                      setSelectStatus(newValue);
                      setSelectCurrentStatus(newValue);
                      // Then trigger the API call
                      clockInEmployees(event);
                    }}
                  >
                    {status &&
                      status.map((st) => (
                        <option
                          key={`status-${st.id}-${st.jobSplitId}`}
                          value={`${st.id}_${st.jobSplitId || ""}`}
                        >
                          {st.description}
                        </option>
                      ))}
                  </TextField>
                  <LocationStatus
                    hasLocation={!!capturedLocation}
                    permission={permission}
                    onClick={() => {
                      if (permission === 'denied' || !capturedLocation) {
                        setShowLocationDialog(true);
                      }
                    }}
                  />
                  {clocking && (
                    <CircularProgress style={{ width: "24px", marginTop: "8px" }} size={24} />
                  )}
                </CardActions>
              </>
            )}
          </div>
          <SidebarNav
            style={{ marginBottom: "0" }}
            className={classes.nav}
            pages={sidebarData}
            openDrawer={open}
            onClose={onClose}
          />
          <div className={classes.otherItems}>
            {!fieldTech && isSqueegeeSquad && (
              <div>
                <Tooltip
                  arrow
                  placement="right"
                  title={
                    (!open && isDesktop && (
                      <Typography color="inherit">Squeegee Squad Dashboard</Typography>
                    )) ||
                    ""
                  }
                >
                  <IconButton
                    className={classes.signOutButton}
                    style={open ? { paddingLeft: 8 } : null}
                    color="inherit"
                    href="https://sites.google.com/squeegeesquad.com/dashboard/home"
                    target="_blank"
                  >
                    <OpenInBrowser />
                    {(open || !isDesktop) && (
                      <Typography className={classes.logoutText}>Squeegee Squad Dashboard</Typography>
                    )}
                  </IconButton>
                </Tooltip>
              </div>
            )}
            <div>
              <Tooltip
                arrow
                placement="right"
                title={
                  (!open && isDesktop && (
                    <Typography color="inherit">Logout</Typography>
                  )) ||
                  ""
                }
              >
                <IconButton
                  className={classes.signOutButton}
                  style={open ? { paddingLeft: 8 } : null}
                  color="inherit"
                  onClick={() => logout()}
                >
                  <InputIcon />
                  {(open || !isDesktop) && (
                    <Typography className={classes.logoutText}>Logout</Typography>
                  )}
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Footer
            style={{ marginTop: "auto" }}
            drawerOpen={open}
            toggleDrawer={handleToggleDrawer}
          />
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ top: "64px" }}
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackBar(false)}
        >
          <Alert
            elevation={6}
            variant="filled"
            severity={isStatus.failed ? "error" : "success"}
          >
            <Typography color="inherit" variant="h6">
              {isStatus.msg}
            </Typography>
          </Alert>
        </Snackbar>

        <ModalAllEmployees
          openConfirm={openConfirmAllEmployees}
          closeConfirm={() => {
            setOpenConfirmAllEmployees(false);
          }}
          onConfirmOne={() => onEmployeeStatusChanged(false)}
          onConfirm={() => onEmployeeStatusChanged(true)}
          lstEmployees={listEmployeesActive}
        ></ModalAllEmployees>

        <LocationCapture
          open={showLocationDialog}
          onClose={() => setShowLocationDialog(false)}
          onLocationCaptured={handleLocationCaptured}
          onSkip={handleLocationSkip}
          captureLocationFn={captureLocation}
        />
      </Drawer>
    );
  } else {
    return (
      <Drawer
        anchor="left"
        classes={{ paper: clsx(classes.drawer, !open ? classes.collapse : "") }}
        onClose={onClose}
        open={open}
        variant={variant}
      >
        <div {...rest} className={clsx(classes.root, className)}>
          <Skeleton circle={true} height={open ? 100 : 48} width={open ? 100 : 48} />
          <Skeleton count={7} style={{ margin: "10px 0" }} />
        </div>
      </Drawer>
    );
  }
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
